import { StringParam, useQueryParam, withDefault } from 'use-query-params'

import type { PrecisionValue } from '@fourthwall/module-analytics'
import { useDateRange, usePrecision } from '@fourthwall/module-analytics'
import { useShopTime } from '@modules/Timezone/providers/ShopTimeProvider'

import type { AnalyticsParams } from '../AnalyticsParams.types'

type AnalyticsParamsConfig = {
  precision?: {
    excluded?: PrecisionValue[]
  }
}

export const useAnalyticsParams = (config?: AnalyticsParamsConfig) => {
  const { getCurrentShopTime } = useShopTime()
  const { dateRange } = useDateRange(getCurrentShopTime())
  const { precision } = usePrecision(dateRange.value, config?.precision?.excluded)
  const fromParams = useQueryParam('from', withDefault(StringParam, ''))
  const toParams = useQueryParam('to', withDefault(StringParam, ''))
  const from = dateRange.value === 'custom' ? fromParams[0] : dateRange.params?.from || ''
  const to = dateRange.value === 'custom' ? toParams[0] : dateRange.params?.to || ''

  const chartEntityParams = useQueryParam<AnalyticsParams['chartEntityGroup']>('chartEntity')
  const tiersIdsParams = useQueryParam<string | undefined>('tiersIds')
  const intervalsParams = useQueryParam<NonNullable<AnalyticsParams['intervals']>[0] | undefined>(
    'intervals',
  )
  const devicesParams = useQueryParam<NonNullable<AnalyticsParams['devices']>[0] | undefined>(
    'devices',
  )

  const getDevices = (devicesParam: NonNullable<AnalyticsParams['devices']>[0] | undefined) => {
    if (devicesParam === 'Web' || devicesParam === 'Apple' || devicesParam === 'Android') {
      return [devicesParam]
    }
  }

  const getIntervals = (
    intervalsParam: NonNullable<AnalyticsParams['intervals']>[0] | undefined,
  ) => {
    if (intervalsParam === 'Month' || intervalsParam === 'Year') {
      return [intervalsParam]
    }
  }

  const getTiers = (tiersIdsParam: string | undefined) => {
    if (!tiersIdsParam || tiersIdsParam === 'ALL') {
      return undefined
    }

    return [tiersIdsParam]
  }

  return {
    queryParams: {
      from: fromParams,
      to: toParams,
      chartEntity: chartEntityParams,
      tiersIds: tiersIdsParams,
      intervals: intervalsParams,
      devices: devicesParams,
    },
    analyticsParams: {
      from,
      to,
      precision: precision.params.precision,
      chartEntityGroup: chartEntityParams[0],
      devices: getDevices(devicesParams[0]),
      intervals: getIntervals(intervalsParams[0]),
      tiersIds: getTiers(tiersIdsParams[0]),
    },
  }
}
